// extracted by mini-css-extract-plugin
export default {"page":"NotAvailablePage_page__iTlbi","state":"NotAvailablePage_state__ehiKS","title":"NotAvailablePage_title__oaDux","body":"NotAvailablePage_body__gzKkn"};